import type { I_apiGetModels, I_apiGetModels_Return } from "./apiGetModels.types.";

import axios from "../configRequest";
import { I_AXIOS } from "../configRequest.model";

const apiGetModels: I_apiGetModels = async (aboutModels) => {
    const fetchData = await axios.post<I_apiGetModels_Return>(
        `${I_AXIOS.STAGE_API_HOST}/api/tin/v1/site/quest/calc/models`,
        aboutModels,
    );
    return fetchData.data;
};

export default apiGetModels;
